import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import { buildListQuery, ListQueryOptions, normalizePaginatedListResponse, PaginatedApiResponse } from '../../../services/paginatedList';

export interface AccCompany {
  id: number;
  name: string;
  code: string;
  intercompanyAccounts?: string | null;
  managementCompanyId?: number | null;
  isVessel: boolean;
  isManagementCompany: boolean;
  isActive: boolean;
  intercompanyAccount?: { id: number; code: string; name: string; combLevel?: string } | null;
  managementCompany?: { id: number; code: string; name: string } | null;
  createdByUser?: {
    id: number;
    userDisplayName?: string | null;
    userFirstName?: string | null;
    userLastName?: string | null;
    userEmail?: string | null;
  } | null;
  updatedByUser?: {
    id: number;
    userDisplayName?: string | null;
    userFirstName?: string | null;
    userLastName?: string | null;
    userEmail?: string | null;
  } | null;
  usedInRecords?: boolean;
  createdAt: string;
  updatedAt: string;
}

export const useAccCompanies = (searchParams?: string, page = 1, limit = 25, options?: ListQueryOptions) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<AccCompany> | AccCompany[]>(
    `${moduleConfig.module.api.list}${q}`,
    fetcher,
    { revalidateOnFocus: true },
  );
  const normalized = normalizePaginatedListResponse<AccCompany>(data, page, limit);
  return { data: normalized.data, total: normalized.total, page: normalized.page, limit: normalized.limit, isLoading, isError: error, mutate };
};

export const useAccCompany = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<AccCompany>(id ? moduleConfig.module.api.detail(id) : null, fetcher);
  return { data, item: data, isLoading, isError: error, mutate };
};
